import styled from '@emotion/styled'
import React from 'react'
import { Container,Grid, Typography } from '@mui/material'

const SecondContainer = styled(Container)`
    background: url("./assets/sec.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding-top:50px;
    padding-bottom:50px;
`
const Heading = styled(Typography)`
    font-size: 60px;
    font-family: poppinBI;
    text-align: center;
    color: #fff;
    text-transform: uppercase;
    -webkit-text-stroke: 1px black;
    @media (max-width: 1065px) and (min-width: 600px){
        font-size: 30px;
    }
    @media (max-width: 600px){
        font-size: 16px;
    }
`
const ContentGrid = styled(Grid)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
`
const TextGrid = styled(Grid)`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-top: 5%;
    margin-left: 2%;
    @media (max-width: 600px){
        margin-top: 20%;
        margin-left: 0%;
    }
`
const TextImg = styled.img`
    position: absolute;
    right: -1%;
    top: 18%;
    z-index: 0;
    width: 50%;
    max-width: 100%;
    @media (max-width: 600px){
        top: 36%;
    }
`
const SubHeading = styled(Typography)`
    font-size: 30px;
    font-family: poppinBI;
    color:#fff;
    text-transform: uppercase;
    -webkit-text-stroke: 1px black;
    @media (max-width: 1065px) and (min-width: 600px){
        font-size: 20px;
    }
    @media (max-width: 600px){
        font-size: 18px;
    }
`
const Desc = styled(Typography)`
    color:#000;
    font-family: poppinBI;
    font-size: 23px;
    text-transform: capitalize;
    @media (max-width: 1065px) and (min-width: 600px){
        font-size: 15px;
    }
    @media (max-width: 600px){
        font-size: 12px;
    }
`
const HeaderDiv = styled.div`
    display: flex;
    transform: rotate(355deg);
    align-items: center;
    margin-bottom: -30px;
    @media (max-width: 600px){
        margin-bottom: -20px;
    }

`
const StarImg = styled.img`
    width:90px;
    @media (max-width: 600px){
        width:60px;
    }
`

export {SecondContainer,Heading,ContentGrid,TextGrid,TextImg,SubHeading,Desc,HeaderDiv,StarImg,}
